import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveAccountTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`account_templates/${uuid}/archive`);
  return response.data;
};

interface UseArchiveAccountTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveAccountTemplate({ uuid, onSuccessCallback }: UseArchiveAccountTemplateProps) {
  return useMutation({
    mutationFn: () => archiveAccountTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAccountTemplates, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the account template. Please try again and contact support if the problem persists.');
      } else {
        console.error('Unexpected error archiving account template:', err);
      }
    },
  });
}
